module.exports = __webpack_public_path__ + "static/media/UserId.3569ea63.svg";